import { getGlobalHeadersAsObject } from "../global-headers";
import type { DRFListResponseWrapper } from "../types";

export type PersonEmailMessage = {
	id: number;
	email_to: string;
	email_from: string;
	folder: string;
	user_id: number | null;
	username: string;
	user_first_name?: string;
	created: string;
	date: string;
	text: string;
	subject: string;
	email_journal_id: number;
	text_display: string;
	message_id: string;
	opened: boolean;
	has_tracking: boolean;
	bounce: boolean;
	has_bounced: boolean;
	x_failed_recipients: boolean;
	auto_submitted: boolean;
	computed_url: string | null;
	// Additional EmailJournal debug fields (no duplicates of existing props)
	external_id: string | null;
	in_reply_to: string | null;
	thread_id: string | null;
	folder_type: number;
	email_method: number | null;
	folder_type_display: string;
	email_method_display: string | null;
	emailqueue_id: number | null;
};

export const getPersonEmailsById = (
	id: number
): Promise<DRFListResponseWrapper<PersonEmailMessage[]>> => {
	if (!id || typeof id !== "number") {
		throw new Error(
			`getPersonConversationsById called with invalid argument id '${id}'. Expected number`
		);
	}

	return fetch(`/api/v2/persons/${id}/email_journal/`, {
		method: "GET",
		headers: getGlobalHeadersAsObject(),
	}).then((res) => res.json());
};

export const deleteEmailJournal = (emailJournalId: number): Promise<void> => {
	if (!emailJournalId || typeof emailJournalId !== "number") {
		throw new Error(
			`deleteEmailJournal called with invalid argument emailJournalId '${emailJournalId}'. Expected number`
		);
	}

	return fetch(`/api/v2/email-stats/${emailJournalId}/`, {
		method: "DELETE",
		headers: getGlobalHeadersAsObject(),
	}).then((res) => {
		if (!res.ok) {
			throw new Error(`Failed to delete email: ${res.statusText}`);
		}
	});
};
